import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Plan from './Plan';
import { getStatus, processCommon } from '../../../../utils/dashboard/processCommon';
import Tooltip from '../../../common/tooltip/Tooltip';

const PreDocVerificationPlans = (props) => {
    const {
        type, 
        preDocVerificationSavedPlans,
        status,
        link,
        effectiveStartDate,
        handleClick
    } = props;

    if (!preDocVerificationSavedPlans || preDocVerificationSavedPlans.length === 0) {
        return (
            <div className="grid-row padding-2">
                <div className="grid-col-10 padding-x-2">
                    <FormattedMessage id={`plans.${type && type.toLowerCase()}_no_plans`}/>
                </div>
                {
                    link &&
                    <div className="grid-col-2 padding-x-2">
                        <a href="#" className="text-underline" onClick={handleClick}>
                            <FormattedMessage id={link}/>
                        </a>
                    </div>
                }

            </div>);
    }

    const result = preDocVerificationSavedPlans.map(savedPlan => (
        <div key={savedPlan.planId}
            className="grid-row padding-2"
        >
            <div className="tablet:grid-col-5 padding-x-2">
                <Plan plan={savedPlan} />
                <Tooltip
                    id='plans.for.member'
                    content={processCommon.getMembers(savedPlan.members)}
                    index={`pre_doc_verification_plan_${savedPlan.planId}`}
                    replacement={{ numMember: savedPlan.members.length }}
                    place='left'
                    contentClassName='gi-txt__capitalize'
                />
            </div>
            <div className="tablet:grid-col-4 padding-x-2">
                { getStatus(type, savedPlan.planId, status, { effectiveStartDate }) }
            </div>
            { link &&
            <div className="tablet:grid-col-3 padding-x-2">
                <div className="text-underline">
                    <a href="#"
                        onClick={handleClick}
                    >
                        <FormattedMessage id={link}/>
                    </a>
                </div>
            </div>
            }
        </div>
    ));

    return (
        <Fragment>
            {result}
        </Fragment>);
};

export default PreDocVerificationPlans;